var disputeInfo = {
    additionalInfo: 'Si tiene algún documento o comentario que pueda ayudar a resolver su disputa, por favor <0>añádalo ahora.</0>',
    cancelThisDispute: 'CANCELAR ESTA DISPUTA',
    redispute: 'VOLVER A DISPUTAR LA TRANSACCIÓN',
    title: 'Resumen de Disputa',
    tooltipContent: 'Estamos trabajando para resolver su disputa; si usted no recibe comunicaciones nuestras en los próximos 10 días hábiles, por favor póngase en contacto a través del Chat en Línea.',
    uploadsOff: 'Si tiene algún documento o comentario que pueda ayudar a resolver su disputa, por favor utilice nuestro <0>Chat en Línea</0> para obtener instrucciones con guía sobre cómo compartirlos con nosotros.'
};
export default disputeInfo;
//# sourceMappingURL=disputeInfo.js.map